<template>
  <v-container fluid class="max-width">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Project Details</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/projects">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="subtitle-2 text--primary">
          <v-col cols="8">
            <v-row dense class="pa-1">
              <v-col cols="6">Title:</v-col>
              <v-col cols="6">{{ project.name}}</v-col>

              <v-col cols="6">
                <span>Scale:</span>
              </v-col>
              <v-col cols="6">
                <span style>{{ project.projectScale && project.projectScale.Name }}</span>
              </v-col>

              <v-col cols="6">Project Lead:</v-col>
              <v-col cols="6">{{ project.lead && project.lead.name }}</v-col>

              <v-col cols="6">Start Date:</v-col>
              <v-col cols="6">{{ project.startDate | date }}</v-col>

              <v-col cols="6">Start Time</v-col>
              <v-col cols="6">{{ project.startTime }}</v-col>
            </v-row>
          </v-col>

          <v-col cols="4">
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  autocomplete="off"
                  hide-details
                  dense
                  outlined
                  v-model="selectedEmployee"
                  :items="employees"
                  label="Search Employee"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-btn @click="addEmployee" :loading="loader" :disabled="loader" color="primary" class="float-right">
                  <v-icon left>mdi-plus</v-icon>Add To Project
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-divider class="mt-4"></v-divider>

        <v-row class="mt-2">
          <v-toolbar color="secondary" flat dense>
            <v-toolbar-title>Assigned Employees</v-toolbar-title>
          </v-toolbar>

          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :items-per-page="200" :headers="headers" :items="projectEmployees">
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="red" text @click="removeModal(item)">
                  <v-icon left>mdi-close</v-icon>Remove From Project
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!--delete dialog -->
    <v-dialog v-model="removeDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Remove Employee from A project</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="removeDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <span
                  class="style-18"
                >Employee Name: {{ employeeRecord.employee && employeeRecord.employee.name }}</span>
              </v-col>

              <v-col cols="12">
                <v-btn color="accent" @click="removeEmployee">
                  <v-icon left>mdi-delete</v-icon>Remove
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of delete modal-->

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>
  
  <script>
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    }
  },
  data: () => ({
    loader: false,
    removeDialog: false,
    employeeRecord: {},
    project: {},
    employees: [],
    projectEmployees: [],
    selectedEmployee: null,
    docCreate: true,
    headers: [
      { text: "Name", value: "employee.name" },
      { text: "Phone No", value: "employee.phone_number" },
      { text: "Email Address", value: "employee.email" },
      { text: "User Name", value: "employee.userName" },
      { text: "Id No", value: "employee.idNo" }
      // { text: "Action", value: "action" }
    ]
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true
    }
  },
  methods: {
    addEmployee() {
      var projectId = parseInt(this.$route.params.id);
      var details = {
        employeeId: this.selectedEmployee,
        projectId: projectId
      };

      const url = "/project-employees";
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("post", { url, data: details })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.fetchProjectEmployees(projectId);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        }).finally(() => {
          self.loader = false;
        })
    },
    removeModal(item) {
      this.employeeRecord = item;
      this.removeDialog = true;
    },
    removeEmployee() {
      const self = this;
      const url = `/project-employees/${this.employeeRecord.id}`;
      this.$store
        .dispatch("remove", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            location.reload();
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/projects/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.project = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });

      // fetch project employees
      this.fetchProjectEmployees(val);
    },
    save(data) {
      const url = "/projects";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.$router.push("/projects");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    fetchEmployees() {
      const self = this;
      this.$store
        .dispatch("get", `/employees`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.employees = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    fetchProjectEmployees(id) {
      const self = this;
      this.$store
        .dispatch("get", `/project-employees/${id}`)
        .then(res => {
          console.log(res);
          if (res.ResultCode == 1200) {
            self.projectEmployees = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.fetchEmployees();
  }
};
</script>